
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-employers/ats-integration",
      function () {
        return require("private-next-pages/for-employers/ats-integration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-employers/ats-integration"])
      });
    }
  